import React, { Component } from 'react';
import {
  Row, Col, Button
} from 'reactstrap';
import classnames from 'classnames';

// constant
import { config } from '../../constants/constant.config';
import './WhatsNew.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown } from '@fortawesome/fontawesome-free-solid';
import Slider from "react-slick";
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

// const title = 'Logout';
// const modalButtons = null;
let { APP_HEADER_LOGO } = config;

class WhatsNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      currentComponent: 'w1',
      height: window.innerHeight,
      width: window.innerWidth,
    }
    this.sliderRef = React.createRef();
  }

  handleNext = () => {
    this.sliderRef.current.slickNext(); // Go to the next slide
  };

  checkUserAgent() {
    // this.state.isMobile = false;
    this.setState({isMobile: false})
    const ua = navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      // this.state.isMobile = true;
      this.setState({isMobile: true})
      return 'mobile'
    } else if (/Chrome/i.test(ua)) {
      return 'chrome'
    } else {
      return 'other'
    }
  }
  componentWillMount() {
    this.checkUserAgent();
    this.setState((prevState) => {
      return { ...prevState };
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeWindow);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeWindow);
  }


  resizeWindow = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  nextComponent = () => {
    // if (this.state.currentComponent === 'w1') {
    //   this.setState({ currentComponent: 'w2' });
    // } else if (this.state.currentComponent === 'w2') {
    //   this.setState({ currentComponent: 'w3' });
    // } else if (this.state.currentComponent === 'w3') {
    //   // this.setState({ currentComponent: 'w3' });
    //   this.goToNextPage();
    // }
    this.goToNextPage();
  }

  goToNextPage = () => {
    this.props.handleGoToNextPage('reg');
  }

  render() {
    // const { currentComponent, height, width } = this.state;
    const sliderSettings = {
      className: "center",
      infinite: true,
      slidesToShow: 1,
      speed: 500,
      dots: false,
      arrows: false
    };
    return (
      <>
        <div id="ob2">
          {/* {this.props.handleGoToNextPage && < div style={{ height: '55px', paddingTop: '5px' }}>
            <img src={APP_HEADER_LOGO} height="64px" width="auto" alt="" />
          </div>
          } */}
          {/* Slider */}
          <Slider ref={this.sliderRef} {...sliderSettings}>
            {/* First Slide Start */}
            <div
              className={classnames(
                { ' margin-left-20 margin-right-20': this.props.width <= 1200 }
              )}
            >
              <Row>
                <Col xs={12} className='text-center'>
                  <div className=' d-flex justify-content-center margin-top-20'>
                    <img src={APP_HEADER_LOGO} height="200px" width="auto" alt="" className='mt-3' />
                  </div>
                  <h1 className="page-title text-center jk-title">Welcome to JK Baadshah</h1>
                  <div className='d-flex flex-wrap justify-content-center'>
                    <h5 className='jk-sub-title'>A loyalty and reward program for our premium customers</h5>
                  </div>
                  <Button
                    className="mb-1 mr-1 btn-pill action-button whats-new-next-button whatsBtn"
                    color="warning"
                    onClick={this.handleNext}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </div>
            {/* First Slide End */}
            {/* Second Slide Start */}
            <div>
              <Row>
                <Col xs={12}>
                  <div className='text-center d-flex flex-wrap justify-content-center margin-top-20'>
                    <h1 className="page-title text-center jk-title allgroup">All group companies under single parent company</h1>
                  </div>
                </Col>
              </Row>
              <Row className='justify-content-center'>
                <Col lg={8} md={12} xs={12}>
                  <div className='orgWrapper'>
                    <Row className='justify-content-center'>
                      <Col lg={4} md={4} xs={6}>
                        <div className='orgBlockInner'>
                          <div className='orgBlock'>
                            <img src="images/org1Icon.png" alt='org1Icon' className='img-fluid orgIcon' />
                            {/* <p>Now add all your subsidiaries having a SAP IDs to your primary SAP ID</p> */}
                            <p>In your primary account (SAP ID), add all your subsidiaries (with SAP ID)</p>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} md={4} xs={6}>
                        <div className='orgBlockInner'>
                          <div className='orgBlock'>
                            <img src="images/org2Icon.png" alt='org2Icon' className='img-fluid orgIcon' />
                            {/* <p>Points will be instantly added in your Primary SAP ID for tyre offtake of all subsidiaries</p> */}
                            <p>Points will be immediately added into your primary account against the tyre offtake from all the subsidiaries</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className='justify-content-center'>
                <Col xs={12} className='text-center'>
                  <Button
                    className="mb-1 mr-1 btn-pill action-button whats-new-next-button whatsBtn"
                    color="warning"
                    onClick={this.handleNext}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </div>
            {/* Second Slide End */}
            {/* Third Slide Start */}
            <div
              className={classnames(
                { ' margin-left-20 margin-right-20': this.props.width <= 1200 }
              )}
              style={{ width: '100%' }}
            >
              <Row>
                <Col xs={12}>
                  <div className='text-center d-flex flex-wrap justify-content-center margin-top-20'>
                    <h1 className="page-title text-center jk-title allgroup">Introducing First Time</h1>
                  </div>
                </Col>
              </Row>
              <Row className='justify-content-center margin-top-25'>
                <Col lg={8} md={12} xs={12}>
                  <div className='introBlick'>
                    <img src="images/org3Icon.png" alt='org1Icon' className='img-fluid orgIcon' />
                    <div className='contentList'>
                      <ul className='introList'>
                        <li> <FontAwesomeIcon icon={faChevronCircleDown} className='arrowIcon' /> Daily points update based on the offtake</li>
                        <li> <FontAwesomeIcon icon={faChevronCircleDown} className='arrowIcon' /> Available on Android, iOS and Web</li>
                        <li> <FontAwesomeIcon icon={faChevronCircleDown} className='arrowIcon' /> Next level engagement</li>
                        <li> <FontAwesomeIcon icon={faChevronCircleDown} className='arrowIcon' /> Tyre service coupons against the points</li>
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="text-align-center">
                {(this.props.handleGoToNextPage
                  //  || currentComponent === 'w1' || currentComponent === 'w2' 
                ) &&
                  <Button
                    className="mb-1 mr-1 btn-pill action-button whats-new-next-button whatsBtn"
                    color="warning"
                    onClick={this.nextComponent}
                  >
                    {/* {currentComponent !== 'w3' ? 'Next' : 'Let’s Get Started'} */}
                    Let’s Get Started
                  </Button>
                }
              </div>
            </div>
            {/* Third Slide End */}
          </Slider>
        </div >
      </>
    );
  }
}

export default WhatsNew;